import { useActiveBeeswaxList } from "@/modules/BeeswaxList/beeswaxList.hook";

export function useAppSiteData({
  isEdit,
  areFilters,
}: {
  isEdit: boolean;
  areFilters: Record<string, boolean>;
}) {
  const {
    data: domainList,
    isLoading: domainListLoading,
    isFetching: domainListFetching,
  } = useActiveBeeswaxList(
    {
      queryParams: { type: "domain" },
      options: { enabled: isEdit && areFilters?.domain_list },
    },
    "withType"
  );
  const {
    data: dealList,
    isLoading: dealListLoading,
    isFetching: dealListFetching,
  } = useActiveBeeswaxList(
    {
      queryParams: { type: "deal_id" },
      options: { enabled: isEdit && areFilters?.deal_id_list },
    },
    "withType"
  );
  return {
    domainList,
    domainListLoading: domainListLoading && domainListFetching,
    dealList,
    dealListLoading: dealListLoading && dealListFetching,
  };
}
